import { render } from "./DefaultModalTitle.vue?vue&type=template&id=406426a1&scoped=true"
import script from "./DefaultModalTitle.vue?vue&type=script&lang=js"
export * from "./DefaultModalTitle.vue?vue&type=script&lang=js"

import "./DefaultModalTitle.vue?vue&type=style&index=0&id=406426a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406426a1"]])

export default __exports__